import { useEffect, useMemo, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperArrow from "../swiper-arrow";
import { Navigation } from "swiper";
import dayjs from "dayjs";
import classNames from "classnames";

const OsteopataCalendar = ({
  availabilities,
  lang,
  selectedDate,
  setSelectedDate,
  setSelectedTime,
}) => {
  const initRef = useRef();
  const [visibleDate, setVisibleDate] = useState();

  const weekdays = useMemo(() => {
    dayjs.locale(lang?.value);
    return dayjs.weekdaysShort();
  }, [lang?.value]);

  const months = useMemo(() => {
    dayjs.locale(lang?.value);
    return dayjs.monthsShort();
  }, [lang?.value]);

  const dates = useMemo(
    () =>
      availabilities?.map((day) => ({
        id: dayjs(day).toISOString(),
        date: day,
        weekday: weekdays[day.day()],
        month: months[day.month()],
        available: !!availabilities?.find((date) => date.isSame(day, "day")),
      })),
    [availabilities, weekdays, months]
  );

  useEffect(() => {
    if (availabilities?.length > 0 && !initRef.current) {
      initRef.current = true;
      setVisibleDate(availabilities[0]);
    }
  }, [availabilities]);

  const prevRef = useRef();
  const nextRef = useRef();

  const today = useMemo(() => dayjs(), []);

  const handleDateSelection = (e) => {
    const selectedDay = e?.currentTarget?.id;
    if (selectedDay) {
      setSelectedDate(dayjs(selectedDay));
      setSelectedTime(false);
    }
  };

  return visibleDate ? (
    <div className="pick-up-slots__days-wrapper" key={visibleDate.toString()}>
      <SwiperArrow swiper={true} prevRef={prevRef} />
      <div className="pick-up-slots__days">
        <Swiper
          modules={[Navigation]}
          slidesPerView="auto"
          slidesPerGroup={7}
          centerInsufficientSlides={true}
          loop={false}
          navigation={{
            prevEl: ".swiper-button--prev",
            nextEl: ".swiper-button--next",
          }}
          spaceBetween={4}
        >
          {dates?.map((day) => (
            <SwiperSlide key={day.id}>
              <button
                key={day.id}
                className={classNames(
                  "pick-up-slots__day",
                  selectedDate &&
                    day?.date?.isSame(selectedDate, "day") &&
                    "pick-up-slots__day--selected",
                  day?.date?.isSame(today, "day") && "pick-up-slots__day--today"
                )}
                id={day.id}
                onClick={handleDateSelection}
                disabled={!day.available}
                type="button"
              >
                <span className="pick-up-slots__day-month">{day?.month?.toUpperCase()}</span>
                <span className="pick-up-slots__day-value">{day?.date?.date()}</span>
                <span className="pick-up-slots__day-name">{day?.weekday}</span>
              </button>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      <SwiperArrow swiper={true} next={true} nextRef={nextRef} />
    </div>
  ) : (
    <div className="loading-spinner" />
  );
};

export default OsteopataCalendar;
